export default {
    welcome: "Hallo Welt"
}
